import { render, staticRenderFns } from "./FullView.vue?vue&type=template&id=80090cd0&scoped=true"
import script from "./FullView.vue?vue&type=script&lang=js"
export * from "./FullView.vue?vue&type=script&lang=js"
import style0 from "./FullView.vue?vue&type=style&index=0&id=80090cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_r4vjonmvno2vgxt4mkj3onxa2i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80090cd0",
  null
  
)

export default component.exports